/**
 * Les routes poussées du lot Activités : celles qu'il fait passer sur le design system.
 *
 * Pontée par le socle : `realizations` — « Activités faites », ouverte par « Voir plus » sous les
 * activités faites. Elle rend l'écran des ports pour un élève dont l'espace est allumé, hors espace
 * parent et hors live, et son écran legacy ailleurs.
 *
 * Ne sont pas pontées, et restent legacy :
 * - `archived-activites` : aucun écran de l'élève n'y mène (le menu « Activités archivées » est
 *   réservé au tuteur et au parent, `TodoListScreen.js:692`), et la maquette retire les archives à
 *   l'élève ;
 * - `all-activities` : le catalogue des modèles d'activité n'a pas de page dans le design system,
 *   et aucun écran de l'élève n'y mène (seul `ChallengesTabScreen`, monté par l'entretien tuteur, et
 *   les ressources du tuteur la poussent).
 *
 * L'écran n'est chargé qu'à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../loadedOnRender"
import { type StudentSpaceRouteTable } from "../studentSpaceRouteTypes"

export const activitiesRoutes: StudentSpaceRouteTable<"activities"> = {
    realizations: loadedOnRender(
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        () => require("./StudentRealizationsScreen").StudentRealizationsScreen,
        "StudentRealizationsScreen"
    ),
}
